import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        // Only probe /me if we actually have a token — avoids noisy 401s on public pages.
        const token = localStorage.getItem('dib_admin_token');
        if (!token) {
            setAdmin(null);
            setLoading(false);
            return;
        }
        try {
            const { data } = await api.get('/auth/me');
            setAdmin(data);
        } catch (_) {
            setAdmin(null);
            localStorage.removeItem('dib_admin_token');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refresh();
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post('/auth/login', { email, password });
        if (data.access_token) {
            localStorage.setItem('dib_admin_token', data.access_token);
        }
        setAdmin({ id: data.id, email: data.email, name: data.name, role: data.role });
        return data;
    };

    const logout = async () => {
        try { await api.post('/auth/logout'); } catch (_) { /* ignore */ }
        localStorage.removeItem('dib_admin_token');
        setAdmin(null);
    };

    return (
        <AuthContext.Provider value={{ admin, loading, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
